import React, { useState, useEffect } from 'react'
import { Link, useHistory, Redirect } from 'react-router-dom/cjs/react-router-dom.min'
import useStateRef from 'react-usestateref';
import { useSelector, useDispatch } from 'react-redux';
import HeaderContainer from './HeaderContainer';
import { organizationDetailsAction } from '../../middleware/organizationDetailsAction';
import OrderDetail from '../ShoppingList/OrderDetail';
import Loader from '../Loader/Loader';
import Helper from '../Helper';
import { APPLICATION_JSON } from '../../middleware/types';


export const CSRSearch = ({ containerObject, templateName, contentId, dataZone }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [searchUsers, setSearchUsers, searchUsersRef] = useStateRef([]);
    const [searchOrders, setSearchOrders, searchOrdersRef] = useStateRef([]);
    const [CurrentOrderId, setCurrentOrderId, currentOrderIdRef] = useStateRef();
    const [showPagination, setShowPagination, showPaginationRef] = useStateRef({ showNext: false, showPrevious: false });
    const [orderPaginationNumbers, setOrderPaginationNumbers, orderPaginationNumbersRef] = useStateRef([]);
    const [currentOrdersPerPage, setCurrentOrdersPerPage, currentOrdersPerPageRef] = useStateRef('12');
    const [currentOrderPage, setCurrentOrderPage, currentOrderPageRef] = useStateRef(0);
    const [errorMsg, setErrorMsg, errorMsgRef] = useStateRef('')
    const [stateAccend, setStateAccend] = useState("true");
    const [priceInfoAmountAccend, setPriceInfoAmountAccend] = useState("true");
    const [currentPaginationIndex, setCurrentPaginationIndex, currentPaginationIndexRef] = useStateRef('');
    const profileDetail = useSelector(state => state.getProfileDetails.profileDetails)
    const [isPageAllowed, setIsPageAllowed, isPageAllowedRef] = useStateRef(false);
    const [enableOrderSubmission, setEnableOrderSubmission, enableOrderSubmissionRef] = useStateRef(false);
    const dispatch = useDispatch();
    const history = useHistory();
    useEffect(() => {
        if (profileDetail) {
            if (profileDetail.transient) {
                history.push('/');
            } else if (profileDetail?.userTypeCheck?.user != 'csr') {
                history.push('/');
            } else if (profileDetail?.userTypeCheck?.user === 'csr') {
                setEnableOrderSubmission(profileDetail?.enableOrderSubmission);
                setIsPageAllowed(true);
            }
        } else {
            setIsPageAllowed(false);
        }
    }, [profileDetail])
    function handleCsrSearch(event) {
        event.preventDefault();
        setIsLoading(true)
        var formUrl = event.target.getAttribute('action');
        var actionUrl = 'api/rest/cb/profile/' + formUrl;
        var formData = new FormData(event.target);
        const formValue = Object.fromEntries(formData.entries());
        fetch(`${window.location.protocol}//${window.location.hostname}/${actionUrl}`, {
            method: 'POST',
            headers: new Headers({
                "content-Type": "application/json",
            }),
            body: JSON.stringify(formValue)
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    document.getElementById('err').classList.add("d-none");
                    const isDisableCsrHeader = false;
                    dispatch(organizationDetailsAction(isDisableCsrHeader))
                    if (res.response.userDetails) {
                        setSearchUsers(res.response.userDetails);
                        if (res.response.nextKey) {
                            setShowPagination({ showNext: true });
                        }

                        document.getElementById("searchOrders").classList.add("d-none");
                        document.getElementById("searchResult").classList.remove("d-none");
                        document.getElementById("searchResult").scrollIntoView({ behavior: 'smooth' });
                    } else if (res.response.orderDetails) {
                        setSearchOrders(res.response.orderDetails);
                        searchOrderPagination();
                        if (searchOrdersRef.current.length < currentOrdersPerPageRef.current) {
                            document.getElementById('order-pagination').classList.add('d-none');
                            document.getElementById('order-pagination').classList.remove('d-block');
                        } else {
                            document.getElementById('order-pagination').classList.remove('d-none');
                            document.getElementById('order-pagination').classList.add('d-block');
                        }
                        document.getElementById("searchResult").classList.add("d-none")
                        document.getElementById("searchOrders").classList.remove("d-none");
                        document.getElementById("searchOrders").scrollIntoView({ behavior: 'smooth' });
                    }
                    setIsLoading(false);
                } else {
                    var errors = res?.errorMessage?.errors;
                    errors && setErrorMsg(errors[0]);
                    document.getElementById("err").classList.remove("d-none");
                    document.getElementById("err").classList.add("d-block");
                    document.getElementById("err").scrollIntoView({ behavior: 'smooth' });
                    document.getElementById("searchResult").classList.add("d-none")
                    document.getElementById("searchOrders").classList.add("d-none")
                    setIsLoading(false);
                }
            })


    }

    function handelOrderId(id) {
        if (currentOrderIdRef.current == id) {
            setCurrentOrderId();
        } else {
            setCurrentOrderId(id);
        }
    }


    function handleOrganization(event) {
        event.preventDefault();
        var userId = event.target.getAttribute('userId');
        const showOrganizationHeader = true;
        dispatch(organizationDetailsAction(userId, showOrganizationHeader))
    }
    async function handleImpersonate(event) {
        event.preventDefault();
        var userId = event.target.getAttribute('userId');
        dispatch(organizationDetailsAction(userId, false));

        var actionUrl = "api/rest/cb/profile/get-impersonate-details";
        var url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var inputMap = { impersonUserId: userId }
        inputMap = JSON.stringify(inputMap);
        var res = await Helper.fetchCallFunction(url, "POST", false, APPLICATION_JSON, inputMap)

        if (res.response != null) {
            window.location.href = "/";
        } else {
            console.log('res.response...', res.response);
        }

    }
    async function searchUserPagination(event, type) {
        event.preventDefault();
        var actionUrl = 'api/rest/cb/profile/search-user-pagination';
        var url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var inputMap = { 'type': type }
        inputMap = JSON.stringify(inputMap);
        var res = await Helper.fetchCallFunction(url, "POST", false, APPLICATION_JSON, inputMap);
        if (res.response != null) {
            setSearchUsers(res.response.response.userDetails);
            if (res.response.response.nextKey && res.response.response.previousKey) {
                setShowPagination({ showNext: true, showPrevious: true });
            }
            else if (res.response.nextKey) {
                setShowPagination({ showNext: true });
            }
            else if (res.response.previousKey) {
                setShowPagination({ showPrevious: true });
            }
            document.getElementById("searchOrders").classList.add("d-none");
            document.getElementById("searchResult").classList.remove("d-none");
            document.getElementById("searchResult").scrollIntoView({ behavior: 'smooth' });
        } else {
            console.log('res.response...', res.response);
        }
    }
    async function searchOrderPagination() {
        var actionUrl = 'api/rest/cb/profile/search-order-pagination';
        var url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var res = await Helper.fetchCallFunction(url, "GET", false, APPLICATION_JSON, '');
        if (res.response != null) {
            setOrderPaginationNumbers(res.response.response);
            if (searchOrdersRef.current.length < currentOrdersPerPageRef.current && orderPaginationNumbersRef.current.length <= 2) {
                document.getElementById('order-pagination').classList.remove('d-block');
                document.getElementById('order-pagination').classList.add('d-none');
            } else {
                document.getElementById('order-pagination').classList.remove('d-none');
                document.getElementById('order-pagination').classList.add('d-block');
            }
        } else {
            console.log('res.response...', res.response);
        }
    }
    function handleChangeOrdersPerPage(event) {
        event.preventDefault();
        var ordersPerPage = document.getElementById('orders-per-page').value;
        setCurrentOrdersPerPage(ordersPerPage);
        handleParticularPage(event);
    }

    var paginationStyle = {
        boxShadow: '0 0 0 0 rgba(13, 110, 253, 0.25)'
    }
    async function handleParticularPage(event, index) {
        if (event) {
            event.preventDefault();
        }
       
        if (event.target.getAttribute('pageNo') === 'Next »') {
            var nextOrderPage = currentOrderPageRef.current + 1;
            setCurrentOrderPage(nextOrderPage);
        } else if (event.target.getAttribute('pageNo') === '« Previous') {
            var previousPage = currentOrderPageRef.current - 1;
            setCurrentOrderPage(previousPage);
        }
        else if (event.target.getAttribute('pageNo')) {
            const pageNo = event.target.getAttribute('pageNo');
            setCurrentOrderPage((parseInt(pageNo)) - 1);
            console.log('currentOrderPage...//', currentOrderPageRef.current);
        }
        var actionUrl = 'api/rest/cb/profile/particular-order-page';
        var url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var inputMap = { "ordersPerPage": currentOrdersPerPageRef.current, currentPage: String(currentOrderPageRef.current) };
        inputMap = JSON.stringify(inputMap);
        var res = await Helper.fetchCallFunction(url, "POST", false, APPLICATION_JSON, inputMap);
        if (res.response != null) {
            setSearchOrders(res.response.response.orderDetails);
            if (searchOrdersRef.current.length < currentOrdersPerPageRef.current) {
                document.getElementById('order-pagination').classList.add('d-none');
                document.getElementById('order-pagination').classList.remove('d-block');
            } else {
                document.getElementById('order-pagination').classList.remove('d-none');
                document.getElementById('order-pagination').classList.add('d-block');
            }
            searchOrderPagination();
            document.getElementById("searchResult").classList.add("d-none")
            document.getElementById("searchOrders").classList.remove("d-none");
            document.getElementById("searchOrders").scrollIntoView({ behavior: 'smooth' });
        } else {
            console.log('res.response...', res.response);
        }
    }
    const handleSortingChange = (event) => {
        setIsLoading(true)
        var accend = "true"
        if (event == "state") {
            accend = stateAccend
           
        } else if (event == "priceInfo.amount") {
            accend = priceInfoAmountAccend
           
        }
        const inputMap = {
            ascendingSort: accend,
            sortProperty: event
        }
        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/redefine-order-search`, {
            method: 'POST',
            headers: new Headers({
                "content-Type": "application/json",
            }),
            body: JSON.stringify(inputMap)
        }).then(res => res.json())
            .then(res => {
                if (res.result == "success") {
                    if (event == "state") {
                        if (stateAccend == "true") {
                            setStateAccend("false")
                        } else {
                            setStateAccend("true")
                        }
                    } else if (event == "priceInfo.amount") {
                        if (priceInfoAmountAccend == "true") {
                            setPriceInfoAmountAccend("false")
                        } else {
                            setPriceInfoAmountAccend("true")
                        }
                    }
                    setSearchOrders(JSON.parse(res.response).orderDetails);
                    setIsLoading(false)
                } else {
                    setIsLoading(false)
                }
            })


    }
    return (
        <>{isPageAllowedRef.current ?
            <>
                {isLoading ? <Loader /> : ""}
                <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-shop-list-detail`} >
                    <div className="c-csr-page">
                        <form method="post" name="csr_user_search" action='csr-user-search' onSubmit={handleCsrSearch} id="csr_user_search" data-hs-cf-bound="true">

                            <div id="content" className="row mx-1">
                                <div className="col-md-12">
                                    <div id="err" className="alert alert-danger col-12 form-error-messages d-none">{errorMsgRef?.current}</div>
                                    <h1 className="c-csr-main-heading">Customer Service Search</h1>
                                    <h2 className="c-csr-secondary-heading">Users</h2>
                                    <div className="mb-3 row">
                                        <label className="col-sm-3 col-form-label fw-bold">Email:</label>
                                        <div className="col-sm-6">
                                            <input name="email" type="text" className="form-control" />

                                        </div>
                                    </div>
                                    <div className="mb-3 row">
                                        <label for="name" className="col-sm-3 col-form-label fw-bold">Name</label>
                                        <div className="col-sm-3">
                                            <input name="firstName" id="firstName" type="text" placeholder="First" className="form-control" />

                                        </div>
                                        <div className="col-sm-3">
                                            <input name="lastName" id="lastName" type="text" placeholder="Last" className="form-control" />

                                        </div>
                                    </div>
                                    <div className="mb-3 row">
                                        <label for="jde" className="col-sm-3 col-form-label fw-bold">JDE Acc#:</label>
                                        <div className="col-sm-6">
                                            <input name="JDENumber" type="text" className="form-control" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-end mx-3">
                                <div className="col-6 col-md-6 text-end">
                                    <input type="submit" className="btn btn-primary" value="Search Users" />
                                </div>
                            </div>
                        </form>
                        <hr />

                        <form method="post" name="csr_order_search" onSubmit={handleCsrSearch} action="csr-search-orders" id="csr_order_search" data-hs-cf-bound="true">

                            <div id="content" className="row mx-1">
                                <div className="col-md-12">
                                    <h2 className="c-csr-secondary-heading mb-2">Orders</h2>

                                    <div className="mb-3 row">
                                        <label className="col-sm-3 col-form-label fw-bold">ATG Order #/ Web Reference#:</label>
                                        <div className="col-sm-6">
                                            <input name="orderRepositoryId" type="text" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="mb-3 row">
                                        <label className="col-sm-3 col-form-label fw-bold">JDE Order#:</label>
                                        <div className="col-sm-6">
                                            <input name="JDENumber" type="text" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="mb-3 row">
                                        <label className="col-sm-3 col-form-label fw-bold">Date From/To</label>
                                        <div className="col-sm-3">
                                            <input name="dateFrom" placeholder="MM_DD_YYYY" type="date" className="form-control" />

                                        </div>
                                        <div className="col-sm-3">
                                            <input name="dateTo" placeholder="MM_DD_YYYY" type="date" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="mb-3 row">
                                        <label className="col-sm-3 col-form-label fw-bold">Status</label>
                                        <div className="col-sm-6">
                                            <select name="orderState" className="form-control form-select">
                                                <option value="">Select...</option>
                                                <option value="SUBMITTED">Submitted to fulfillment</option>
                                                <option value="TEMPB2I">Temp B2I</option>
                                                {!enableOrderSubmissionRef.current ? <option value="REQUIRES_JDE_SYNC">Order addresses need jde numbers</option> : ''}

                                            </select>
                                        </div>
                                    </div>
                                    <div className="mb-3 row">
                                        <label className="col-sm-3 col-form-label fw-bold">Email Address</label>
                                        <div className="col-sm-6">
                                            <input name="email" type="text" className="form-control" />
                                        </div>
                                    </div>
                                    <div className="mb-3 row">
                                        <label className="col-sm-3 col-form-label fw-bold">Items # in Order</label>
                                        <div className="col-sm-6">
                                            <input name="itemNumber" type="text" className="form-control" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-end mx-3">
                                <div className="col-6 col-md-6 text-end mb-5">
                                    <input type="submit" className="btn btn-primary" value="Search Orders" />
                                </div>
                            </div>
                        </form>

                        <div id="searchResult" className="hidden d-none">
                            <div className="c-csr-table" style={{ padding: "0px 15px 0px 15px" }}>
                                {showPaginationRef.current &&
                                    <div className="category-list-bar-csr">
                                        <div className="row justify-content-between">
                                            <nav aria-label="Page navigation example">
                                                <ul className="c-pagination pagination justify-content-start pagination-lg">
                                                    {showPaginationRef.current.showPrevious &&
                                                        <li className="page-item">
                                                            <Link onClick={(event) => searchUserPagination(event, 'previous')} className="page-link">«Previous</Link>
                                                        </li>
                                                    }
                                                    {showPaginationRef.current.showNext &&
                                                        <li className="page-item">
                                                            <Link onClick={(event) => searchUserPagination(event, 'next')} className="page-link">Next»</Link>
                                                        </li>
                                                    }
                                                </ul>
                                            </nav>
                                        </div>
                                    </div>
                                }
                                <ul className="c-shop-list">
                                    <li className="c-shop-list-item c-shop-list-header d-none d-md-flex">
                                        <span className="c-shop-list-content w-25">FirstName</span>
                                        <span className="c-shop-list-content w-25">LastName</span>
                                        <span className="c-shop-list-content w-25">Role/Status</span>
                                        <span className="c-shop-list-content w-25">Email</span>
                                        <span className="c-shop-list-content w-25">Spending Limit</span>
                                        <span className="c-shop-list-content w-25"></span>
                                    </li>
                                    {searchUsersRef.current && searchUsersRef.current.map((user, index) => {
                                        return (
                                            <li className="c-shop-list-item c-shop-list-body">
                                                <div className="c-list-left">
                                                    <span className="c-shop-list-content">{user.firstName}</span>
                                                    <span className="c-shop-list-content">{user.lastName}</span>
                                                    <span className="c-shop-list-content">{user.role}</span>
                                                    <span className="c-shop-list-content c-csr-overflow">{user.email}</span>
                                                    <span className="c-shop-list-content"></span>
                                                </div>
                                                <div className="c-list-right c-csr-right text-end">
                                                    <button id="Impersonate" onClick={handleImpersonate} userId={user.userId} className="btn c-shop-btn c-list-btn-action">Impersonate</button>
                                                    <button id="Organization" onClick={handleOrganization} userId={user.userId} className="btn c-shop-btn c-list-btn-action">Organization</button>
                                                </div>

                                            </li>
                                        )
                                    })}

                                </ul>
                            </div>
                        </div>


                        <div id='searchOrders' className="d-none">
                            <div className="c-csr-table" style={{ padding: "0 15px 0 15px" }}>
                                {orderPaginationNumbersRef.current &&
                                    <div id='order-pagination' className="category-list-bar-csr">
                                        <div className='row'>
                                            <div className='col-12 col-md-6'>
                                                <div className="row justify-content-between">
                                                    <nav aria-label="Page navigation example">
                                                        <ul className="c-pagination pagination justify-content-start pagination-lg">
                                                            <li className={orderPaginationNumbersRef.current.includes('« Previous') ? "page-item" : "page-item disabled"} >
                                                                <Link className='page-link' onClick={handleParticularPage} pageNo='« Previous' >
                                                                    « Previous
                                                                </Link>
                                                            </li>
                                                            {orderPaginationNumbersRef.current && orderPaginationNumbersRef.current.map((pageNo, index) => {
                                                                return (<>

                                                                    {pageNo !== 'Next »' && pageNo !== '« Previous' &&

                                                                        <li key={index} className={pageNo == currentOrderPageRef.current + 1 ? 'page-item disabled' : "page-item"} >
                                                                            <Link className={`${pageNo !== '...' ? 'page-link' : 'pe-none'}`} onClick={(event) => handleParticularPage(event, index)} id={`paginationId${index}`} index={index} pageNo={pageNo} >
                                                                                {pageNo}
                                                                            </Link>
                                                                        </li>
                                                                    }

                                                                </>
                                                                )
                                                            })}

                                                            <li className="page-item" >
                                                                <Link className={orderPaginationNumbersRef.current?.includes('Next »') ? 'page-link' : 'page-item disabled'} onClick={handleParticularPage} pageNo='Next »' >
                                                                    Next »
                                                                </Link>
                                                            </li>

                                                        </ul>
                                                    </nav>
                                                </div>
                                            </div>
                                            <div className='col-12 col-md-6'>
                                                <div className='perpage-view justify-content-end'>
                                                    <form className='d-flex'>
                                                        <select className='form-select form-select-sm' id='orders-per-page' onChange={handleChangeOrdersPerPage}>
                                                            <option value='12' selected='selected'>12</option>
                                                            <option value='24'>24</option>
                                                            <option value='48'>48</option>
                                                            <option value='60'>60</option>
                                                        </select>
                                                        <label className='form-label align-self-center'>
                                                            Per page
                                                        </label>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <ul className="c-shop-list">
                                    <li className="c-shop-list-item c-shop-list-header d-none d-md-flex c-csr-bar px-2">
                                        <div className="c-list-left">
                                            <span className="c-shop-list-content csr-order-email">User Email</span>
                                            <span className="c-shop-list-content csr-order-order">Order Number</span>
                                            <span className="c-shop-list-content csr-order-status">
                                                Order Status <p className="sort" id="orderStatus" style={{ cursor: "pointer" }} onClick={() => handleSortingChange("state")}></p>
                                                {/* <Link className="sort" onClick={handleSortOrderStatus} id="sortWebNumber" sortName="orderStatus">Sort</Link> */}
                                            </span>
                                            <span className="c-shop-list-content">Order Date</span>
                                            <span className="c-shop-list-content">Promised Date</span>
                                            <span className="c-shop-list-content">MOT</span>
                                            <span className="c-shop-list-content text-md-end">
                                                Order Total<p className="sort" id="orderTotal" style={{ cursor: "pointer" }} onClick={() => handleSortingChange("priceInfo.amount")}></p>
                                                {/* <Link className="sort" onClick={handleSortOrderTotal} id="sortWebNumber" sortName="orderTotal">Sort</Link> */}
                                            </span>
                                        </div>
                                    </li>
                                    <div className="accordion" id="accordianForCsrOrder">
                                        {searchOrdersRef.current && searchOrdersRef.current.map((order, index) => {
                                            return (

                                                <div className="accordion-item">
                                                    <li className="accordion-header c-shop-list-item c-shop-list-body c-csr-body-section px-2" id={`accordion-header_csr_${index}`}>
                                                        <div className="c-list-left">
                                                            <span className="c-shop-list-content csr-order-email">
                                                                <span className='d-block d-md-none c-shop-mobile-label'>
                                                                    <strong>User Email: </strong>
                                                                </span>
                                                                <>{order.userEmail && order.userEmail}</>
                                                            </span>
                                                            <span className="c-shop-list-content csr-order-order">
                                                                <span className='d-block d-md-none c-shop-mobile-label'>
                                                                    <strong>Order Number: </strong>
                                                                </span>
                                                                <button className="c-csr-btn" onClick={() => { handelOrderId(order?.orderId) }} data-bs-toggle="collapse" data-bs-target={"#accordion_" + index} aria-expanded="true" aria-controls={"accordion_" + index}>
                                                                    <Link>{order.orderNumber && order.orderNumber}</Link>
                                                                </button>
                                                            </span>
                                                            <span className="c-shop-list-content csr-order-status">
                                                                <span className='d-block d-md-none c-shop-mobile-label'>
                                                                    <strong>Order Status: </strong>
                                                                </span>
                                                                <button className="c-csr-btn" onClick={() => { handelOrderId(order?.orderId) }} data-bs-toggle="collapse" data-bs-target={"#accordion_" + index} aria-expanded="true" aria-controls={"accordion_" + index}>
                                                                    <Link>{order.orderStatus && order.orderStatus}</Link>
                                                                </button>
                                                            </span>
                                                            <span className="c-shop-list-content">
                                                                <span className='d-block d-md-none c-shop-mobile-label'>
                                                                    <strong>Order Date: </strong>
                                                                </span>
                                                                {order.orderDate && order.orderDate}</span>
                                                            <span className="c-shop-list-content">
                                                                <span className='d-block d-md-none c-shop-mobile-label'>
                                                                    <strong>Promised Date: </strong>
                                                                </span>
                                                                {order.earliestPromisedDate && order.earliestPromisedDate}</span>
                                                            <span className="c-shop-list-content">
                                                                <span className='d-block d-md-none c-shop-mobile-label'>
                                                                    <strong>MOT: </strong>
                                                                </span>
                                                                {order.priorityShippingMethod && order.priorityShippingMethod}</span>
                                                            <span className="c-shop-list-content text-md-end">
                                                                <span className='d-block d-md-none c-shop-mobile-label'>
                                                                    <strong>Order Total: </strong>
                                                                </span>
                                                                {order.totalAmount && order.totalAmount}</span>
                                                        </div>
                                                    </li>

                                                    <div id={"accordion_" + index} className="accordion-collapse collapse" aria-labelledby={`accordion-header_csr_${index}`} data-bs-parent="#accordianForCsrOrder">

                                                        {currentOrderIdRef.current && currentOrderIdRef.current && order.orderId === currentOrderIdRef.current &&
                                                            <div className="accordion-body px-0 py-0">
                                                                <OrderDetail orderId={currentOrderIdRef.current} userId={order.userId} isCSR="true" isOrderTempB2I={order.isOrderTempB2I} hasOrderNumber={order.orderNumber ? true : false} />

                                                            </div>}
                                                    </div>
                                                </div>


                                            )
                                        })
                                        }</div>
                                </ul>
                            </div>
                        </div>


                    </div>
                </div>
            </>
            :
            <></>
        }
        </>
    )
}

